import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { Offline, Detector } from 'react-detect-offline'
import CommonModal from '../Modals/common'
import _ from 'lodash'
import ErrorModal from '../Modals/error'
import { renderField } from '../../components/utils/input'
import validate from './validate'
import './styles.scss'

class ResetPassword extends Component {
  constructor() {
    super()
    this.state = {
      showResetPassword: false,
      showError: false
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.navigate = this.navigate.bind(this)
  }

  componentWillReceiveProps(np) {
    const { resetPasswordData, signOut } = np
    if (resetPasswordData && resetPasswordData.data.newPassword) {
      this.setState({ showResetPassword: true })
    } else if (_.get(np.resetPasswordData, 'errors[0].message', false)) {
      signOut()
      this.setState({ showError: true })
    }
  }

  // Api call to reset the password for the token
  onSubmit(data) {
    let payload = {}
    payload.password = data.confirmPassword
    payload.token = this.props.match.params.token
    const { resetPassword } = this.props
    resetPassword(payload)
  }
  // Will be called from child modal component
  navigate() {
    const { history } = this.props
    this.setState({ showError: false, showResetPassword: false })
    history.push('/login')
  }
  // Will be called from child modal component
  closeModal() {
    this.setState({ showError: false, showResetPassword: false })
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <div>
        <main id="forgotPassword-page">
          <Detector
            render={({ online }) => (
              <div className={online ? '' : 'internet-offline'}>
                <Offline>You are offline at the moment!</Offline>
              </div>
            )}
          />
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 align-middle  align-items-center justify-content-center">
                    <h1 className="page-title d-none d-sm-block">Reset Password</h1>
                    <Link className="close" to="/login">
                      <img alt="" src="/img/close-icon.png" />
                    </Link>
                  </div>
                </div>
              </div>
            </header>
            <div className="forgotpass-form  d-flex align-items-center">
              <div className="container">
                <div className="row ">
                  <div className="col-md-12">
                    <div className="page-inner-container">
                      <h1 className="page-title d-md-none">Reset Password</h1>
                      <div className="form">
                        <form className="form" onSubmit={handleSubmit(this.onSubmit)}>
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">New Password</label>
                            <div className="input-box">
                              <Field
                                name="newPassword"
                                component={renderField}
                                type="password"
                                className="form-control email-icon"
                                placeholder="Enter new password"
                                autoComplete="off"
                              />
                              <img className="img-fluid emailimg-icon password-icon" alt="" src="/img/password-icon.svg" />
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Confirm Password</label>
                            <div className="input-box">
                              <Field
                                name="confirmPassword"
                                component={renderField}
                                type="password"
                                className="form-control email-icon"
                                placeholder="Confirm password"
                                autoComplete="off"
                              />
                              <img className="img-fluid emailimg-icon password-icon" alt="" src="/img/password-icon.svg" />
                            </div>
                          </div>
                          <button type="submit" className="btn btn-primary btn-lg btn-block submit-btn">
                            Reset Password
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CommonModal key="resetPassword" modalType="resetPassword" open={this.state.showResetPassword} {...this.props} closeModal={this.navigate} />
          <ErrorModal modalType="resetPasswordError" open={this.state.showError} {...this.props} closeModal={this.closeModal} />
        </main>
      </div>
    )
  }
}

export default reduxForm({
  form: 'resetPassword', // a unique identifier for this form
  destroyOnUnmount: true,
  validate
})(ResetPassword)



// WEBPACK FOOTER //
// ./src/views/ResetPassword/component.js